import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getErrorMessage } from '../../utils/errorMessage';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { SignUpFormTerms } from '../routes/user/form/SignUpFormTerms';
import { validateAutomaticSignup } from '../signup.api';
import '../routes/signup_form.scss';
import {
  ModalConfirmationContainer,
  ModalConfirmationHeaderNoClose,
  ModalConfirmationFooter,
  ModalConfirmationContent,
  ModalActions,
} from '../../components/modal';
import { BrandButton } from '../../components/button';
import styles from './signup_validation_modal.module.scss';

type State = {
  password: string;
  error: string;
  loading: boolean;
  seePassword: boolean;
  agreedToTerms: boolean;
};

type Props = {
  closeModal: () => void;
  isOpen: boolean;
};

export class SignUpValidationModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = {
    password: '',
    error: '',
    loading: false,
    seePassword: false,
    agreedToTerms: false,
  };

  handleTerms = () => {
    this.setState(state => ({ agreedToTerms: !state.agreedToTerms }));
  };

  submitSetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { password, agreedToTerms } = this.state;
    const res = window.location.pathname.match(
      /signup_validation\/.*\/(?<token>.*)/,
    );
    const verificationToken = res && res.groups ? res.groups.token : '';
    try {
      this.setState({ loading: true });
      await validateAutomaticSignup({
        password,
        agreedToTerms,
        verificationToken,
      });
      window.location.href = '/?source=signup-validation-modal';
    } catch (error) {
      if (error.response) {
        this.setState({
          error: getErrorMessage(error.response),
          loading: false,
        });
      } else {
        throw error;
      }
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ password: event.target.value, loading: false });
  };

  toggleSeeClearPassword = () => {
    doctrineAnalytics('Account SeePasswordToggle', { source: 'set-password' });
    this.setState(({ seePassword }) => ({
      seePassword: !seePassword,
    }));
  };

  render() {
    const { agreedToTerms } = this.state;
    const { isOpen, closeModal } = this.props;
    return (
      <ModalConfirmationContainer
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
      >
        <ModalConfirmationHeaderNoClose
          title={
            <FormattedMessage id="signup/signup-validation/SignUpValidationModal.tsx/1" />
          }
        />
        <form onSubmit={this.submitSetPassword}>
          <ModalConfirmationContent>
            <label htmlFor="input-password" className={styles.label}>
              <div className={styles.labelGroup}>
                <div>
                  <FormattedMessage id="signup/signup-validation/SignUpValidationModal.tsx/2" />{' '}
                  <span className={styles.labelDiscreet}>
                    <FormattedMessage id="signup/signup-validation/SignUpValidationModal.tsx/3" />
                  </span>
                </div>
                <button
                  type="button"
                  className={styles.seeButton}
                  onClick={this.toggleSeeClearPassword}
                >
                  {this.state.seePassword ? 'Masquer' : 'Afficher'}
                </button>
              </div>
              <input
                required
                id="input-password"
                type={this.state.seePassword ? 'text' : 'password'}
                value={this.state.password}
                onChange={this.handleChange}
                spellCheck={false}
              />
            </label>
            <SignUpFormTerms
              handleTerms={this.handleTerms}
              agreedToTerms={agreedToTerms}
              jobTitle=""
              USER_JOBS={[]}
            />
            {this.state.error && (
              <div className={styles.error}>{this.state.error}</div>
            )}
          </ModalConfirmationContent>
          <ModalConfirmationFooter>
            <ModalActions>
              <BrandButton disabled={this.state.loading} type="submit">
                {this.state.loading ? 'Envoi en cours...' : 'Valider le compte'}
              </BrandButton>
            </ModalActions>
          </ModalConfirmationFooter>
        </form>
      </ModalConfirmationContainer>
    );
  }
}
